import React, { Component } from "react";
import { v4 } from "uuid";
import { getName, getIntials } from "../../helper";
import ShareWithDetails from "../SharedWith/SharedWithDetails/SharedWithDetails";
import "./SharedWith.scss";

class SharedWith extends Component {
  state = {
    sharedwith: [],
  };
  componentDidMount() {
    let sharedItems = this.props.isFolder
      ? this.props.item.sharedFolder
      : this.props.item.sharedDocument;
    sharedItems = sharedItems
      .filter(
        (sharedItem) =>
          sharedItem.user.profile.role.name !== "IT Admin" &&
          sharedItem.user.profile.role.name !== "Admin"
      )
      .map((sharedItem) => {
        return {
          document: this.props.isFolder ? null : { id: this.props.itemId },
          folder: this.props.isFolder ? { id: this.props.itemId } : null,
          ...sharedItem,
        };
      });
    this.setState({ sharedwith: sharedItems });
  }

  componentDidUpdate(prevProp) {
    if (prevProp !== this.props) {
      let sharedItems = this.props.isFolder
        ? this.props.item.sharedFolder
        : this.props.item.sharedDocument;
      sharedItems = sharedItems
        .filter(
          (sharedItem) =>
            sharedItem.user.profile.role.name !== "IT Admin" &&
            sharedItem.user.profile.role.name !== "Admin"
        )
        .map((sharedItem) => {
          return {
            document: this.props.isFolder ? null : { id: this.props.itemId },
            folder: this.props.isFolder ? { id: this.props.itemId } : null,
            ...sharedItem,
          };
        });
      this.setState({ sharedwith: sharedItems });
    }
  }

  getSharedList = () => {
    let sharedWithList = [...this.state.sharedwith];
    let currentItemSharedList = this.props.isFolder
      ? sharedWithList.filter(
          (sharedItem) =>
            sharedItem.folder && sharedItem.folder.id === this.props.itemId
        )
      : sharedWithList.filter(
          (sharedItem) =>
            sharedItem.document && sharedItem.document.id === this.props.itemId
        );
    return currentItemSharedList;
  };

  render() {
    // let array_length = this.props.sharedWithState.length;
    let userSharedList = [...this.state.sharedwith];
    let array_length = userSharedList.length;
    let shareLimit = 4;
    let sharedList;
    let count;

    if (array_length > 0) {
      if (array_length < shareLimit + 2) {
        sharedList = userSharedList.map((uKey) => (
          <ShareWithDetails
            key={v4()}
            uKey={uKey}
            nameIntial={getIntials(uKey.user)}
            personName={getName(uKey.user)}
            profile={uKey.user.profile.image}
            isPopover={this.props.isPopover}
            role={uKey.userRole.name}
          />
        ));
      } else {
        count = array_length - shareLimit;
        sharedList = userSharedList
          .slice(0, shareLimit)
          .map((uKey, index) => (
            <ShareWithDetails
              key={v4()}
              uKey={uKey}
              nameIntial={getIntials(uKey.user)}
              personName={getName(uKey.user)}
              profile={uKey.user.profile.image}
              isPopover={this.props.isPopover}
              role={uKey.userRole.name}
            />
          ));
      }
    }

    return (
      <div className="d-flex" key={v4()}>
        {sharedList}
        {count ? (
          <div className="sharedwith-details">
            <div className="sharedwith-details-initials p-1">+{count}</div>
          </div>
        ) : null}
      </div>
    );
  }
}

export default SharedWith;
